import { Grid, Typography, useScrollTrigger } from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import { useStore } from "react-redux";

import { useResponsive } from "../../../../hooks/useResponsive";
import filterIcon from "../../../../styles/svg/epic-icon.svg";
import {
  addAllBoard,
  searchCard,
  setDateRange,
} from "../../../../redux/SearchSlice";
import {
  setAllGroupUser,
  setGroupUser,
} from "../../../../redux/TaskGroupingSlice";
import { useTeams } from "../../../../utils/reactQuery/teams";
import { fixedDigitsAfterDecimal } from "../../../../utils";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useUsers } from "../../../../utils/reactQuery/users";
import DrawerGlobalComp from "../../../../components/Drawer";
import { MobileFilters, MemoizedMobileFilters } from "./MobileFilters";
import { CustomButton } from "../../../../components/Button/Button";
import { useSetMultipleParams } from "../../../../hooks/useSetMultipleParams";
import newSearchIcon from "../../../../styles/svg/newSearchIcon.svg";
import GlobalSearch from "../../../../components/Search";

function Header() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchParam] = useCustomSearchParams("txt");
  const workHours = useSelector((state) => state.search.totalWorkHours);
  const dispatch = useDispatch();
  const isMobile = useResponsive("down", "md");
  const trigger = useScrollTrigger();
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );
  const selectedBoard = useSelector((state) => state.search.boardSearch);
  const [setMultipleSearchParams] = useSetMultipleParams();
  const Olddate = useMemo(() => searchParams.get("date"), [searchParams]);
  const { teams, isLoading: teamIsLoading } = useTeams();
  const [filterdUser, setFilterUser] = useState([]);
  const [userParams, setUserParams] = useCustomSearchParams("uid");
  const { users, isLoading: usersIsLoading } = useUsers();

  const [openSearchField, setOpenSearchField] = useState(false);
  const [searchInputParam, setSearchParam, removeSearchParam] =
    useCustomSearchParams("txt");
  const store = useStore();

  useEffect(() => {
    setInputValue(searchParam || "");
    dispatch(searchCard(searchParam || ""));
  }, []);

  useEffect(() => {
    if (teams && users) {
      if (userParams && userParams[0]) {
        userParams?.split(",").forEach((element) => {
          dispatch(
            setGroupUser(
              users.data.data.responseData.find(
                (user) => user.user_id === element * 1
              )
            )
          );
        });
      }
    }
  }, [teamIsLoading, usersIsLoading]);

  const removeSearchParams = useCallback(
    (paramsToRemove) => {
      const newSearchParams = new URLSearchParams(searchParams);
      paramsToRemove.forEach((param) => {
        newSearchParams.delete(param);
      });
      setSearchParams(newSearchParams);
    },
    [searchParams, setSearchParams]
  );

  const clearFilters = useCallback(() => {
    dispatch(addAllBoard([]));
    dispatch(setAllGroupUser([]));
    dispatch(setDateRange(null));
    removeSearchParams(["date", "board","uid"]);
  }, [dispatch, removeSearchParams]);

  useEffect(() => {
    setInputValue(searchParam || "");
    dispatch(searchCard(searchParam || ""));
  }, [searchParam, dispatch]);

  useEffect(() => {
    if (Olddate && isMobile) {
      const date = JSON.parse(Olddate);
      const obj = {
        startDate: new Date(date.startDate),
        endDate: new Date(date.endDate),
        key: "selection",
      };
      dispatch(setDateRange(obj));
    }
  }, [Olddate, isMobile, dispatch]);

  const handleApplyWorklogFilter = useCallback(() => {
    const currentState = store.getState();
    const currentBoardSearch = currentState.search.boardSearch;
    const currentGroupingUser = currentState.groupingUser.allocationUsers;
    const updatedSearchParams = [];

    updatedSearchParams.push({
      name: "board",
      value: currentBoardSearch.join(","),
    });
    updatedSearchParams.push({
      name: "uid",
      value: (currentGroupingUser[0]?.users || [])
        .map((item) => item.user_id)
        .join(","),
    });

    setMultipleSearchParams(updatedSearchParams);
    setFilterDrawer(false);
  }, [setMultipleSearchParams, store]);

  const handleOpenSearchField = useCallback(() => {
    setOpenSearchField(!openSearchField);
  }, [openSearchField]);

  const debouncedSearch = useRef(
    _.debounce((value) => {
      dispatch(searchCard(value));
      setSearchParam("txt", value);
    }, 300)
  ).current;

  const handleChange = useCallback(
    (event) => {
      const value = event.target.value.trimStart();
      setInputValue(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  return (
    <>
      {isMobile ? (
        <div
          className="pos-sticky mt-4 ml-4 mb-2 mobile-worklog-header-div"
          style={{ top: trigger ? "0px" : "50px" }}>
          {openSearchField ? (
            <Grid
              container
              item
              xs={12}
              className="remove-container-width fixed-ui mobile-search-field"
              justifyContent={"center"}
              alignItems={"center"}>
              <GlobalSearch
                placeholder={"Search..."}
                searchText={inputValue}
                handleChange={handleChange}
                onCancel={handleOpenSearchField}
                showCancel={true}
                fullWidth={true}
              />
            </Grid>
          ) : (
            <div className="d-flex mb-2 mr-3 justify-content-space-between align-items-center ">
              <div className="d-flex align-items-center">
                <Typography className="worklog_head">Worklogs</Typography>

                <span className="hours-header ml-2">
                  {fixedDigitsAfterDecimal(workHours)} hours
                </span>
              </div>
              <div className="d-flex align-items-center mobile-search-icon-div">
                <img
                  src={newSearchIcon}
                  className="mobile-board-search-icon"
                  alt="search"
                  onClick={handleOpenSearchField}
                />
                <img
                  src={filterIcon}
                  alt="filter"
                  style={{ marginRight: "8px" }}
                  onClick={() => setFilterDrawer(true)}
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="d-flex justify-content-space-between mb-4">
          <div className="d-flex">
            <p className="worklog_head mr-4">Worklogs</p>
            <span className="hours-header">
              {fixedDigitsAfterDecimal(workHours)} hours
            </span>
          </div>
        </div>
      )}
      {true && (
        <DrawerGlobalComp open={filterDrawer} setOpen={setFilterDrawer}>
          <MemoizedMobileFilters
            clearFilters={clearFilters}
            groupingUser={store.getState().groupingUser.allocationUsers}
            teams={teams}
          />

          <div className="mt-4">
            <CustomButton
              variant="contained"
              color="primary"
              onClick={handleApplyWorklogFilter}
              className="mobile-board-filter-apply-btn">
              Apply
            </CustomButton>
          </div>
        </DrawerGlobalComp>
      )}
    </>
  );
}

export default React.memo(Header);
